import Icon from 'veui/components/Icon'

Icon.register({
  'menu-slider': {
    paths: [
      {
        d: 'M1.6 3.2h20.86a1.6 1.6 0 000-3.2H1.6a1.6 1.6 0 000 3.2zm20.86 25.6H1.6a1.6 1.6 0 000 3.2h20.86a1.6 1.6 0 000-3.2zm15.42-13.93l-6.79-6.8a1.6 1.6 0 00-2.71 1.16c0 .43.17.82.45 1.11l4 4H1.67a1.6 1.6 0 000 3.2h31.28l-4.1 4.11a1.6 1.6 0 001.14 2.72c.44 0 .83-.17 1.12-.45l6.78-6.8a1.6 1.6 0 000-2.25z'
      }
    ],
    width: '38',
    height: '32'
  }
})
